import(/* webpackMode: "eager" */ "/vercel/path0/apps/premiere-plugin/src/app/(workspace)/[workspaceId]/layout.tsx");
